import { useCallback, useMemo } from 'react';
import { useTracking } from '@edreamsodigeo/frontend-core';
import { useOffer } from '@/providers/PriceFreezeOfferProvider';
import { useCurrentPage } from '@/hooks/useCurrentPage';
import { getPageView, getCategoryPage, replaceDeposit } from './tracking.utils';
import { TRACKING_ACTION } from './tracking.map';
import { useLogin } from '@/providers/login/LoginProvider';
import {
  pageMapper,
  useCustomTrackingPage,
} from '@/providers/tracking/PriceFreezeTrackingProvider';
import { useIsActivePrimeUser } from '@/providers/PrimeUserProvider';

export const usePFTracking = () => {
  const { trackEvent, trackPage: _trackPage } = useTracking();

  const customPage = useCustomTrackingPage();
  const page = useCurrentPage();
  const { isPrime, isLogged } = useLogin();
  const { isActive } = useIsActivePrimeUser() || false;
  const isActivePrimeEmail = isActive != null ? isActive : false;
  const offer = useOffer();

  const trackPage = useCallback(
    (pageview = '', funnel = 'price-freeze') => {
      _trackPage(pageview || getPageView({ page, customPage }), { funnel });
    },
    [_trackPage, page, customPage]
  );

  const track = useCallback(
    (action, customCategory, customPageName) => {
      const category = getCategoryPage({ page, customPage });

      const label = `${TRACKING_ACTION}${replaceDeposit(
        action,
        offer?.deposit
      )}_prime:${
        isPrime || (isActivePrimeEmail && !isLogged) ? 'yes' : 'no'
      }_pag:${customCategory || category}`;
      trackEvent({
        category: customCategory || category,
        action: TRACKING_ACTION,
        label,
        page: pageMapper(customPageName || page || customPage),
      });
    },
    [isPrime, page, customPage, offer, trackEvent, isLogged, isActivePrimeEmail]
  );

  return useMemo(() => {
    return { track, trackPage };
  }, [track, trackPage]);
};
